import { createSlice } from "@reduxjs/toolkit";

type SubItem = string | { id: string; subItems: string[] };

type Extension = {
  id: string; // e.g., "diamond", "jewellery"
  subItems: string | SubItem[]; // e.g., ["shapes", "prices"]
};

interface initialStateType {
  role: string;
  extensions: Extension[];
  filteredMenu: Object[];
  error: string | null;
}

const extensions = localStorage.getItem("extensions");
const parsedExtensionData = extensions ? JSON.parse(extensions) : [];
const userRole = localStorage.getItem("userRole");

export const initialState: initialStateType = {
  role: userRole || "",
  extensions: parsedExtensionData,
  filteredMenu: [],
  error: null,
};

const SettingsSlice = createSlice({
  name: "Settings",
  initialState,
  reducers: {
    setFilteredMenu: (state: initialStateType, action: { payload: any[] }) => {
      state.filteredMenu = action.payload;
    },
    setRoleConfig: (
      state: initialStateType,
      action: { payload: { role: string; extensions: Extension[] } }
    ) => {
      state.role = action.payload.role;
      state.extensions = action.payload.extensions;
    },
    // Action to handle error in loading role config
    setError: (state: initialStateType, action: { payload: string }) => {
      state.error = action.payload; // Set error message in state
    },
  },
});

export default SettingsSlice.reducer;
export const { setFilteredMenu, setRoleConfig, setError } =
  SettingsSlice.actions;
